import { render } from "./TWAS.vue?vue&type=template&id=039f7344"
import script from "./TWAS.vue?vue&type=script&lang=js"
export * from "./TWAS.vue?vue&type=script&lang=js"

import "./TWAS.vue?vue&type=style&index=0&id=039f7344&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__